import React from 'react';

import * as S from './styles';
import { useUser } from 'global/UserContext';
import Categories from 'microfrontends/Education/AdminEducation/Categories';

export const OrchestratorEducationCategories = () => {
  const { user } = useUser();
  const userId = user?.id;

  return (
    <S.Wrapper>
      <S.Content>{userId && <Categories key="categories" userId={userId} />}</S.Content>
    </S.Wrapper>
  );
};
